import React from "react";
import { Col } from "react-bootstrap";
import IndicatorPerson from "./IndicatorPerson";
import "./IndicatorPeopleList.css";

function IndicatorPeopleList({ people, language }) {
  return (
    <Col className="indicator-people-list">
      {people.map((element) => (
        <IndicatorPerson
          key={element._id}
          id={element._id}
          firstName={element.firstName}
          lastName={element.lastName}
          profileName={element.profileName}
          profileNameEnglish={element.profileNameEnglish}
          language={language}
        />
      ))}
    </Col>
  );
}

export default IndicatorPeopleList;
